import { useCallback } from 'react';

import { useOnCurrentTimeChanged as useOnCurrentStreamTimeChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentTimeChanged';

import { Time } from '../types/time';

export const useOnCurrentTimeChanged = (callback: (currentTime: Time) => void, delay: number) => {
    /** @see OTT-82541 if need hide preroll timeline */
    const prerollDuration = 0;

    const callbackWrapped = useCallback(
        (streamTime: number) => {
            callback(new Time(streamTime, prerollDuration ?? 0));
        },
        [callback, prerollDuration]
    );

    useOnCurrentStreamTimeChanged(callbackWrapped, delay);
};
